import { render, staticRenderFns } from "./NewFooter.vue?vue&type=template&id=bb6ef704&scoped=true"
import script from "./NewFooter.vue?vue&type=script&lang=js"
export * from "./NewFooter.vue?vue&type=script&lang=js"
import style0 from "./NewFooter.vue?vue&type=style&index=0&id=bb6ef704&prod&lang=scss&scoped=true"
import style1 from "./NewFooter.vue?vue&type=style&index=1&id=bb6ef704&prod&lang=scss"
import style2 from "./NewFooter.vue?vue&type=style&index=2&id=bb6ef704&prod&lang=scss"
import style3 from "./NewFooter.vue?vue&type=style&index=3&id=bb6ef704&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6ef704",
  null
  
)

export default component.exports